export class FormEvent {

	target;

	formstatuses = {};

	reset;

	constructor(form, statuses, reset) {
		this.formstatuses = statuses;
		this.target = form;
		this.reset = reset;
	}

	locateFailed(correction = 40, autoscroll = true) {
		const root = document.documentElement;
		const rootTop = root.scrollTop;
		const errorTop = Object.keys(this.formstatuses).reduce(
			(result, current) => {
				if (!this.formstatuses[current].isInvalid) return result;
				const error = this.target.querySelector(
					`[name="${current}"], [data-alias="${current}"]`
				);

				return Math.min(
					root.scrollTop + ((error && error.getBoundingClientRect().top) || 0),
					result
				);
			},
			rootTop
		);

		if (errorTop === rootTop) return rootTop;

		return autoscroll
			? (root.scrollTop = errorTop - correction)
			: errorTop - correction;
	}

	isReady() {
		const form = this.formstatuses;

		return Object.keys(form).every((name) => !form[name].isInvalid);
	}

	forEach(callback) {
		const form = this.formstatuses;
		Object.keys(form).forEach((field) =>
			callback(form[field].value, form[field].aliasOf || field)
		);
	}

	json() {
		const result = {};

		this.forEach((value, name) => {
			const isArray = name.endsWith('[]');
			name = name.replace('[]', '');
			if (name in result) {
				if (Array.isArray(result[name])) {
					result[name].push(value);
				} else {
					result[name] = [result[name], value];
				}
			} else {
				result[name] = isArray && !Array.isArray(value) ? [value] : value;
			}
		});

		return result;
	}

	paramArray() {
		const result = [];

		this.forEach((value, name) => result.push({ name, value }));

		return result;
	}

	param() {
		return this.paramArray()
			.reduce(
				(result, current) =>
					(result += Array.isArray(current.value)
						? current.value.reduce(
								(res, val) => (res += `&${current.name}=${val}`),
								''
						  )
						: `&${current.name}=${current.value}`),
				''
			)
			.substr(1);
	}

	formData() {
		return new FormData(this.target);
	}
}
